// extracted by mini-css-extract-plugin
export default {"fr-view":"Participants_fr-view__wt27o","collaborators":"Participants_collaborators__Wl5Dw"};